import { DomainIcon } from '../icons/DomainIcon';
import { Icon, type IconSize } from '../icons/Icon';
import type { NavIconSpec } from './navModel';

export function NavIcon({ icon, size = 20 }: { icon: NavIconSpec; size?: IconSize }) {
  return icon.kind === 'domain' ? (
    <DomainIcon id={icon.id} size={size} />
  ) : (
    <Icon icon={icon.icon} size={size} />
  );
}
